import React, { PureComponent } from 'react';
import PopupToApplyVisaCard from './PopupToApplyVisaCard';
import tile from '../../assets/img/accessories/media/images-accessories/VVC.svg';
import { updateSCTags } from './../../service/dtmTag';
import { getVZDLInit } from '../../service/vzdl';
import { store } from './../../index';
import { connect } from 'react-redux';

class MarketingTile extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showFirstPopup: false,
      taggingDetails:"Apply for Verizon VISA Card"
    };
  }
  
  openFirstPopup = () => {
    this.setState({
      showFirstPopup: true
    });
    updateSCTags("details")
    let visitIdVal = store && store.getState() && store.getState().appVTP && store.getState().appVTP.visitId ? store.getState().appVTP.visitId : "";
    setTimeout(()=>{
      getVZDLInit(visitIdVal,"keep_previous_page_name", '', '', this.state.taggingDetails, 'Accessories', '', '')
    },1000)
   
  };

  closeFirstPopup = (value="") => {
    this.setState({
      showFirstPopup: false
    });
    if(value==="close1"){
      updateSCTags("close sign")
    }
  };
  componentDidMount(){
    let url = window.location.href
    if (url.indexOf("s/checkout")>-1) {
      this.setState({
        taggingDetails: "Apply for Verizon VISA Card and earn 1",
      });
    }
    else{
      this.setState({
        taggingDetails: "Apply for Verizon VISA Card",
      });
    }
  }

  render() {
    return (
      <div className="tile-outer-box">
        <div className="tile-inner-box">
          <div>
            <p className="tile-content-box">
              Apply for Verizon Visa® Card and earn 1% in Verizon Dollars.
              <br />
              <a onClick={this.openFirstPopup}>
                <span style={{ textDecoration: 'underline' }}>Details</span>
              </a>
              {<PopupToApplyVisaCard showFirstPopup={this.state.showFirstPopup} closeFirstPopup={this.closeFirstPopup} ></PopupToApplyVisaCard>}
            </p>
          </div>
        </div>
        <div className="tile-image">
          <img src={tile} alt="VVCImage" />
        </div>
      </div>
    );
  }
  
}
const mapStateToProps = (state) => {
  return {
    appState: state.appVTP,
    categoriesState: state.categoriesVTP,
    productstate: state.productsVTP,
    cartProduct: state.cartProductDataVTP,
  };
};

export default  connect(mapStateToProps)(MarketingTile);
